import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

import { DomainContext } from "../../domain-repository/DomainRepository";

import AlertModalManager from "../../components/alert-modal-wraper/alert-modal-manager";
import { validateKeylessRA } from "./keylessService";
import Loading from "../../components/Loading";
import { KeylessModal } from "./components/KeylessModal";
import {
  bigImageStyle,
  bigModalStyle,
  errorModalImgStyle,
  keylessColors,
} from "./utils";
import { KeylessButton } from "./components/KeylessButton";
import { ProgressBar } from "./components/ProgressBar";

export function KeylessValidateRA({ handleNextStep, keylessToken }) {
  const { t } = useTranslation();

  const { localizationAssets } = useContext(DomainContext);

  const [isLoading, setIsLoading] = useState(true);

  const [modalObj, setModalObj] = useState({
    title: "keylessWaitTitle",
    message: "keylessLoadingVehicleMessage",
    img: "keylessLoadingVehicle",
  });
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return null;
    hasRun.current = true;
    let tm = null;
    validateKeylessRA(keylessToken)
      .then((res) => {
        setIsLoading(false)
        setModalObj({
          title: "keylessVehicleSucessTitle",
          message: "",
          img: "keylessSuccess",
        });

        tm = setTimeout(() => {
          handleNextStep(res.nextStep);
        }, 2500);
      })
      .catch((err) => {
        setIsLoading(false);
        setModalObj({
          title: "keylessWarning",
          message: "keylessVehicleErrorTitle",
          img: "keylessError",
          error: true,
        });
      });

    return () => {
      if (tm) clearTimeout(tm);
    };
  }, [keylessToken, handleNextStep]);

  const handleLeaveClick = useCallback(() => {
    window.location.href = "/";
  }, []);

  return (
    <div>
      <div style={styles.page}>
        <div className="container" style={styles.pageContent}>
          <img
            src={localizationAssets["keylessGuerinLogo"]}
            alt="Guerin"
            style={styles.logo}
          />
        </div>
      </div>
      <KeylessModal
        isOpen={true}
        title={t(modalObj.title)}
        message={t(modalObj.message)}
        img={localizationAssets[modalObj.img]}
        modalStyle={modalObj.error ? {} : bigModalStyle}
        imgStyle={modalObj.error ? errorModalImgStyle : bigImageStyle}
        actions={
          modalObj.error ? (
            <KeylessButton onClick={handleLeaveClick} text={t("leave")} />
          ) : <ProgressBar done={!isLoading} />
        }
      />
    </div>
  );
}

const styles = {
  page: {
    backgroundColor: keylessColors.green,
    height: "100dvh",
    paddingBottom: "60px",
    paddingTop: "20px",
    fontFamily: "'BlissLight'",
  },
  pageContent: {
    textAlign: "center",
    height: "100%",
  },
  logo: {
    width: "150px",
    margin: "0 auto",
  },
};
